import { render, staticRenderFns } from "./UploadVerifactuDialog.vue?vue&type=template&id=2c3f7459&scoped=true"
import script from "./UploadVerifactuDialog.vue?vue&type=script&lang=js"
export * from "./UploadVerifactuDialog.vue?vue&type=script&lang=js"
import style0 from "./UploadVerifactuDialog.vue?vue&type=style&index=0&id=2c3f7459&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3f7459",
  null
  
)

export default component.exports